export const preventDoubleSubmitEnhancer = function (form) {
    form.addEventListener('submit', function () {
        const submitButtons = form.querySelectorAll('[type="submit"]');
        Array.from(submitButtons, function (button) {
            button.disabled = true;
        });
    });
};
